/* eslint no-param-reassign: ["error", { "props": false }] */
import React from 'react';
import './Partners.css';
import UnderlinedButton from '../../underlinedButton/UnderlinedButton';
import { eventTypes, trackEvent } from '../../helpers/AnalyticsManager';

import amtc from '../../images/home/partners/amtc.png';
import aneel from '../../images/home/partners/aneel.png';
import hp from '../../images/home/partners/hp.png';
import inria from '../../images/home/partners/inria.png';
import lg from '../../images/home/partners/lg.png';
import jcpm from '../../images/home/partners/jcpm.png';
import icmbio from '../../images/home/partners/icmbio.png';
import sebrae from '../../images/home/partners/sebrae.png';
import informa from '../../images/home/partners/informa.png';
import manguezal from '../../images/home/partners/manguezal.png';
import portodigital from '../../images/home/partners/portodigital.png';
import samsung from '../../images/home/partners/samsung.png';
import tugraz from '../../images/home/partners/tugraz.png';
import harvard from '../../images/home/partners/harvard.png';
import kyushu from '../../images/home/partners/kyushu.png';
import tum from '../../images/home/partners/tum.png';

import logoEmbrapii from '../../images/home/icon_embrapii.png';
import efeitoTech01 from '../../images/home/efeito_03.png';

class PartnersSection extends React.Component {
  constructor() {
    super();

    this.state = {
      partners: [
        { name: 'hp', logo: hp },
        { name: 'samsung', logo: samsung },
        { name: 'informa', logo: informa },
        { name: 'lg', logo: lg },
        { name: 'jcpm', logo: jcpm },
        { name: 'sebrae', logo: sebrae },
        { name: 'manguezal', logo: manguezal },
        { name: 'portodigital', logo: portodigital },
        { name: 'icmbio', logo: icmbio },
        { name: 'amtc', logo: amtc },
        { name: 'aneel', logo: aneel },
        { name: 'inria', logo: inria },
        { name: 'tu-graz', logo: tugraz },
        { name: 'harvard', logo: harvard },
        { name: 'kyushu', logo: kyushu },
        { name: 'tum', logo: tum },
      ],
    };
  }

  render() {
    const { partners } = this.state;

    return (
      <div className="Partners">
        <h4>Clients and Partners</h4>
        <div className="partnersList">
          <ul>
            { partners.map(partner => <li key={partner.name}><img className="partnerLogo" src={partner.logo} alt={`${partner.name} company logo`} /></li>) }
          </ul>
        </div>
        <div id="morePartners">
          <UnderlinedButton
            title="MODELOS DE PARCERIA"
            redirect="/industry"
            whiteMode
            beforeAction={() => trackEvent(eventTypes.homePartnership)}
          />
        </div>

        <div id="embrapii">
          <div className="cont_embrapii">
            <img id="efeitoTech01" src={efeitoTech01} alt="" />
            <div className="textoEmbrapii01">
              <h1>
Certificate
                <br />
                  Unity
              </h1>
            </div>
            <div className="logo_embrapii">
              <img src={logoEmbrapii} alt="Embrapii - Empresa Brasileira de Pesquisa e Inovação Industrial" />
            </div>
            <div className="textoEmbrapii02">
              <h1>
Innovation
                <span>in</span>
                {' '}
                <br />
                  vehicle technology
              </h1>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default PartnersSection;
